export default __webpack_public_path__ + "static/media/warning_img.8876a555.png";